import { render, staticRenderFns } from "./DeliverableType.vue?vue&type=template&id=722866dc&"
import script from "./DeliverableType.vue?vue&type=script&lang=js&"
export * from "./DeliverableType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports